<!--物流码明细-->
<template>
    <el-dialog
            title="物流码明细"
            :visible="true"
            :append-to-body=true
            width="50%"
            :before-close="handleClose">
        <!--表格-->
        <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                height="350"
                border
                stripe
                style="width: 100%">
            <el-table-column
                    prop="code_name"
                    label="标签类型"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="logistics_code"
                    label="物流码"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="real_return_goods_num"
                    label="数量"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="is_feeling_goods"
                    label="是否窜货"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.is_feeling_goods == 0">未窜货</span>
                    <span v-else>已经窜货</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="from_name"
                    label="窜货客户"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="isgift"
                    label="是否赠品"
                    show-overflow-tooltip>

                <template slot-scope="scope">
                    <span v-if="scope.row.isgift == 1">赠品</span>
                    <span v-if="scope.row.isgift == 2">赠品</span>
                  <!--  <span v-else>全部</span>-->
                    <span></span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="stock_out_sn"
                    label="原发货单号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="sotck_out_time"
                    label="原发货时间"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>

    </el-dialog>
    
</template>

<script>
    export default {
        name: "deliver-code",
        data() {
            return {
                loading:false,
                tableData:[],
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
            }
        },
        props:{
            return_goods_sn:{
                type:String,
                default:''
            }
        },
        methods: {
            getData(){
                let url = '/returngoods/'+this.return_goods_sn+'/datas';
                this.loading = true;
                this.$get('logistics',url, {
                    lang:'',
                    returngoods:this.return_goods_sn,
                    per_page:this.pageSize,
                    page:this.pageNo
                }).then(res => {
                    console.log(res);
                    this.loading = false;
                    this.tableData = res.data;
                    this.totalSize = res.meta.total;
                }).catch(function (error) {
                    this.loading = false;
                    //console.log(error);
                });
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getData();
            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created() {
            this.getData();
        },
    }
</script>

<style lang="scss" scoped>

</style>